(function() {
    // 注册组件
    SR.component.extend('videoPlayer', videoPlayer);
    function videoPlayer() {
        if (!SR.state.isSmartRobot) {
            return;
        }
        var $win = SR.dom.$win;
        var $body = SR.dom.$body;
        var networkStatus = {};
        var winW = $win.width();
        var winH = $win.height();
        var videoTimer;
        var loadingTimer;

        var $videoWrap = $('<div class="video-player-wrap"></div>');
        var $closeBtn = $('<div class="close-btn J_closeVideo">✕</div>');
        var $video = $('<video class="video-player" type="video/mp4" controls webkit-playsinline playsinline></video>');
        // var $videoLoading = $('<div class="video-loading"><div class="ai-item"></div></div>');
        var $videoLoading = $('<div class="video-loading"><div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div>');

        var $networkMask = $('<div class="network-status-mask"></div>');
        var $modal = $('<div class="network-status-modal"></div>');
        var $tips = $('<div class="tips"></div>');
        var $buttons = $('<div class="buttons"></div>');

        var mobileNetworkTips = '当前为非wifi网络环境，是否继续播放？';
        var noneNetwordTips = '当前网络网络不可用，请检查网络连接';
        var $continuePlayBtn = $('<div class="video-btn continue-play J_continuePlayVideo">继续播放</div>');
        var $stopPlayBtn = $('<div class="video-btn pause-play J_closeVideo">停止播放</div>');
        var $closeModalBtn = $('<div class="video-btn close J_closeModal">关闭</div>');

        $body.on('click', '.J_closeModal', function() {
            $networkMask.hide();
        });

        $body.on('click', '.J_closeVideo', function() {
            $videoWrap.find('.video-player').empty().remove();
            $videoWrap.remove();
            SR.state.videoPlaying = false;
        });

        $body.on('click', '.J_continuePlayVideo', function() {
            $networkMask.hide();
            autoPlay($video);
        });

        $body.on('click', '.J_playVideo', function() {
            var $me = $(this);
            var src = $me.attr('data-src');
            var poster = $me.attr('data-poster');
            $video.attr({ src: src, poster: poster });
            $videoWrap.css({
                width: winW,
                height: winH
            });
            // 视频居中
            $video.css({
                width: winW,
                height: winH
            });
            $modal.append($tips, $buttons);
            $networkMask.append($modal);
            $videoWrap.append($video, $videoLoading, $closeBtn, $networkMask);
            $body.append($videoWrap);
            SR.state.videoPlaying = true;
        
            networkStatus.callback = function(code, param) {
                var param = JSON.parse(param);
                switch (param.ret) {
                    case 'wifi':
                        autoPlay($video);
                        break;
                    case 'other':
                        $tips.text(mobileNetworkTips);
                        $buttons.empty().append($continuePlayBtn, $stopPlayBtn);
                        pausePlay($video);
                        $networkMask.show();
                        break;
                    case 'none':
                        $tips.text(noneNetwordTips);
                        $buttons.empty().append($closeModalBtn);
                        pausePlay($video);
                        $networkMask.show();
                        break;
                }
            };

            if (SR.state.isNative && !SR.state.isDebug) {
                upNativeComm.exec('Network.getConnectionInfo', networkStatus);
            } else {
                if (SR.state.isDebug) {
                    // TEST
                    // var ret = 'other';
                    // switch (ret) {
                    //     case 'wifi':
                    //         autoPlay($video);
                    //         break;
                    //     case 'other':
                    //         $tips.text(mobileNetworkTips);
                    //         $buttons.empty().append($continuePlayBtn, $stopPlayBtn);
                    //         pausePlay($video);
                    //         $networkMask.show();
                    //         break;
                    //     case 'none':
                    //         $tips.text(noneNetwordTips);
                    //         $buttons.empty().append($closeModalBtn);
                    //         pausePlay($video);
                    //         $networkMask.show();
                    //         break;
                    // }
                } else {
                    autoPlay($video);
                }
            }
            
            if(loadingTimer) {
                clearTimeout(loadingTimer);
            }
            loadingTimer = setTimeout(function () {
                $videoLoading.hide();
            }, 3000);

            $video.off().on('playing', function() {
                $videoLoading.hide();
            }).on('waiting', function() {
                $videoLoading.show();
            }).on('pause', function() {
                $videoLoading.hide();
            });
        });

        function autoPlay($video) {
            if (videoTimer) {
                clearTimeout(videoTimer);
            }
            videoTimer = setTimeout(function() {
                $video.get(0).play();
            }, 200);
        }

        function pausePlay($video) {
            if (videoTimer) {
                clearTimeout(videoTimer);
            }
            videoTimer = setTimeout(function() {
                $video.get(0).pause();
            }, 200);
        }

        SR.App.on('askFire', function() {
            var $videoWrap = $('.video-player-wrap');
            if ($videoWrap.length) {
                $videoWrap.find('.video-player').get(0).pause();
                $videoWrap.remove();
            }
        });
    }
})();
